import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgDemo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="3 0 18 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M20.741 5v2.285h-1.136v6.95c0 .601-.502 1.09-1.117 1.09h-1.983l1.696 3.537h-1.435l-.034-.07-1.653-3.467h-1.863v3.537h-1.261v-3.537h-1.863l-1.686 3.537H6.97l1.696-3.537H6.682c-.615 0-1.116-.489-1.116-1.09v-6.95H4.331V5h16.41zm-2.377 2.285H6.806v6.83h11.558v-6.83zm-8.265 3.788c.354 0 .64.266.64.593 0 .328-.286.594-.64.594h-.42c-.354 0-.642-.266-.642-.594 0-.327.288-.593.641-.593zm5.331 0c.353 0 .64.266.64.593 0 .328-.287.594-.64.594h-3.329c-.353 0-.641-.266-.641-.594 0-.327.288-.593.641-.593zm-5.281-2.056c.353 0 .64.266.64.593 0 .328-.287.594-.64.594h-.42c-.355 0-.642-.266-.642-.594 0-.327.287-.593.641-.593zm5.33 0c.353 0 .641.266.641.593 0 .328-.288.594-.64.594h-3.331c-.354 0-.641-.266-.641-.594 0-.327.287-.593.641-.593z"
      />
    </svg>
  );
}

export default tombacIcon('Demo')(SvgDemo);
